import * as React from 'react'
import { IDiscountCode } from '@user/store/discountCode/typings'
import { FC } from 'react'
import { getStyles } from './styling'
import { useTabs } from './hooks/useTabs'
import { TabPanel } from '@sales-center/components'
import { useLineItemsReferralTypeLists } from './hooks/useLineItemsReferralTypeLists'
import { DiscountLineItemCardList } from './DiscountLineItemCardList/DiscountLineItemCardList'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { Theme, useTheme } from '@mui/material/styles'
interface Props {
  referralDiscountCode: IDiscountCode
}

export const ReferralDiscountDetails: FC<Props> = (props) => {
  const { referralDiscountCode } = props

  const codeAndDescription = referralDiscountCode
    ? `${referralDiscountCode.code} - ${referralDiscountCode.name}`
    : null

  const [tabIndex, handleTabChange] = useTabs()

  const [existingCustomerItems, newCustomerItems] =
    useLineItemsReferralTypeLists(referralDiscountCode.discountLineItems)

  const existingCustomerHelperText =
    existingCustomerItems.length > 0
      ? 'Referrer will get a discount on these Services'
      : 'Referrer will not get a discount on Services'

  const newCustomerHelperText =
    newCustomerItems.length > 0
      ? 'Lead or Opportunity will get a discount on these Services'
      : 'Lead or Opportunity will not get a discount on Services'
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.body}>
      <Box sx={styles.sectionHeading}>Selected Referral Code</Box>
      <Box>{codeAndDescription}</Box>
      <Box sx={styles.sectionHeading}>
        Description of Selected Referral Code
      </Box>
      <Box>
        {referralDiscountCode.description || (
          <Box component="span" sx={styles.noContent}>
            No Description
          </Box>
        )}
      </Box>
      <Box sx={styles.sectionHeading}>Terms</Box>
      <Box>
        {referralDiscountCode.terms || (
          <Box component="span" sx={styles.noContent}>
            No Terms
          </Box>
        )}
      </Box>
      <Box sx={styles.sectionHeading}>Eligible Services</Box>
      <Box>
        The services below are associated with the referral discount code
        applied. Associated discounts will be applied according to company
        policy.
      </Box>
      <Tabs
        sx={{
          indicator: styles.indicator,
          marginTop: (theme: Theme) => theme.spacing(2.4),
        }}
        onChange={handleTabChange}
        value={tabIndex}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="New Customer - Referee" value={0} />
        <Tab label="Existing Customer - Referrer" />
      </Tabs>
      <TabPanel value={0} tab={tabIndex}>
        <Box sx={styles.tabContainer}>{newCustomerHelperText}</Box>
        <Box>
          <DiscountLineItemCardList lineItems={newCustomerItems} />
        </Box>
      </TabPanel>
      <TabPanel value={1} tab={tabIndex}>
        <Box sx={styles.tabContainer}>{existingCustomerHelperText}</Box>
        <DiscountLineItemCardList lineItems={existingCustomerItems} />
      </TabPanel>
    </Box>
  )
}
